import { motion } from "framer-motion";
import { useLang } from "@/lib/i18n";
import { FLEET } from "@/data/content";
import { SectionHead } from "./Reveal";

export const Fleet = () => {
  const { t, lang } = useLang();
  return (
    <section id="frota" className="relative py-28 md:py-40 bg-[#0E0E12]" data-testid="fleet-section">
      <div className="mx-auto max-w-[1440px] px-5 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-8">
          <SectionHead over={t.fleet.over} lines={t.fleet.title} testid="fleet-heading" />
          <p className="max-w-xs text-sm text-zinc-400">{t.fleet.note}</p>
        </div>
        <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {FLEET.map((f, i) => (
            <motion.div key={f.id}
              initial={{ opacity: 0, y: 60 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true, amount: 0.15 }}
              transition={{ duration: 1, delay: i * 0.1, ease: [0.16, 1, 0.3, 1] }}
              className={`group ${i % 2 === 1 ? "lg:mt-16" : ""}`} data-testid={`fleet-card-${f.id}`}>
              <div className="relative aspect-[3/4] overflow-hidden rounded-t-full border border-white/10 group-hover:border-[#C5A059]/50 transition-colors duration-700">
                <img src={f.img} alt={f.name[lang]} loading="lazy"
                  className="h-full w-full object-cover grayscale-[70%] brightness-75 transition-[transform,filter] duration-[1200ms] group-hover:grayscale-0 group-hover:brightness-90 group-hover:scale-105" />
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_30%,transparent_30%,#0A0A0C_100%)] opacity-80" />
              </div>
              <div className="mt-6 flex items-baseline justify-between gap-3">
                <h3 className="font-display text-3xl text-[#F9F9F9]">{f.name[lang]}</h3>
                <span className="text-[11px] uppercase tracking-[0.25em] text-[#C5A059]">{String(i + 1).padStart(2, "0")}</span>
              </div>
              <p className="mt-1 text-sm text-zinc-400">{f.tag[lang]}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
